import { fork, all } from 'redux-saga/effects'
import { processSaga, watchSaga, chainSagas, fanSagas } from '../workflow'
// eslint-disable-next-line import/no-named-as-default, temporary until we only export the one thing
import actionTypes from '../../actionTypes'
import actionWorkflows from '../../actionWorkflows'
import addItemVersion from '../../../dataservices/addItemVersion'
import setItemOwn from '../../../dataservices/setItemOwn'
import setItemWant from '../../../dataservices/setItemWant'
import getItemByItemKey from '../../../dataservices/getItemByItemKey'
import getPostsByItemKey from '../../../dataservices/getPostsByItemKey'
import getBrandByBrandKey from '../../../dataservices/getBrandByBrandKey'
import getFeatureVotesByUidAndItemKey from '../../../dataservices/getFeatureVotesByUidAndItemKey'
import getItemOwnWants from '../../../dataservices/getItemOwnWants'
import { selectItemOwnByKey, getParamsForItemFetch } from './sagas'

const itemFetchingActions = [
	actionTypes.itemFetch_Success,
	actionTypes.userProfileItemsOwnedFetch_Success,
	actionTypes.userProfileItemsWantedFetch_Success,
	actionTypes.userProfilePostsFetch_Success,
	actionTypes.searchItem_Success,
	actionTypes.feedFetch_Success,
	actionTypes.kitFetch_Success,
	actionTypes.postFetch_Success
]

const itemFetchWorkflow = processSaga.bind(null, actionWorkflows.itemFetch, getItemByItemKey)
const itemBrandFetchWorkflow = processSaga.bind(null, actionWorkflows.itemBrandFetch, ({ item }) => getBrandByBrandKey(item.brandKey))
const itemFeatureVotesFetchWorkflow = processSaga.bind(null, actionWorkflows.itemFeatureVotesFetch, ({ item, uid }) => getFeatureVotesByUidAndItemKey({ uid, itemKey: item.itemKey }))
const itemPostsFetchWorkflow = processSaga.bind(null, actionWorkflows.itemPostsFetch, getPostsByItemKey)
const itemVersionAddWorkflow = processSaga.bind(null, actionWorkflows.itemVersionAdd, addItemVersion)
const itemOwnSetWorkflow = processSaga.bind(null, actionWorkflows.itemOwnSet, setItemOwn)
const itemWantSetWorkflow = processSaga.bind(null, actionWorkflows.itemWantSet, setItemWant)
const itemOwnWantFetchWorkflow = processSaga.bind(null, actionWorkflows.itemOwnWantFetch, getItemOwnWants)

const itemRelatedFetchChain = fanSagas.bind(null, [itemBrandFetchWorkflow, itemPostsFetchWorkflow, itemFeatureVotesFetchWorkflow])
const itemFetchChain = chainSagas.bind(null, [itemFetchWorkflow, itemRelatedFetchChain])

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, actionTypes.itemFetch, itemFetchChain, { latest: true, selectParams: getParamsForItemFetch })),
		fork(watchSaga.bind(null, actionTypes.itemOwnSet, itemOwnSetWorkflow)),
		fork(watchSaga.bind(null, actionTypes.itemVersionAdd, itemVersionAddWorkflow)),
		fork(watchSaga.bind(null, actionTypes.itemWantSet, itemWantSetWorkflow)),
		fork(watchSaga.bind(null, itemFetchingActions, itemOwnWantFetchWorkflow, { selectParams: selectItemOwnByKey }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/items/index.js